import { render, staticRenderFns } from "./quesInstru10.vue?vue&type=template&id=01fcaf07"
import script from "./quesInstru10.vue?vue&type=script&lang=js"
export * from "./quesInstru10.vue?vue&type=script&lang=js"
import style0 from "./quesInstru10.vue?vue&type=style&index=0&id=01fcaf07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports